/* eslint-disable react/prop-types */
import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Button, Modal, Container, Form, Col, Row } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';

import './AddFiles.css';
import {
    DiscussionContext,
    useGlobalContext,
} from '../../../Context/index.tsx';
import { globalURLS } from '../../../Global/urls.js';
import useDiscussionsClubsHostsInternalHosts from '../../../hooks/useDiscussionsClubsHostsInternalHosts.tsx';

function AddFiles() {
    const { openAddFilesModal, setAddFilesModal } = useContext(
        DiscussionContext.AddDiscussionFilesContext,
    );

    const { setShowSuccessToast, setShowErrorToast } = useGlobalContext();

    const [selectedDiscussion, setSelectedDiscussion] = useState(null);
    const [existingFiles, setExistingFiles] = useState([]);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [updatingFileId, setUpdatingFileId] = useState(null);
    const [inputList, setinputList] = useState([
        { name: '', file: null, authorid: '' },
    ]);
    const [validated, setValidated] = useState(false);

    const getSelectDiscussions = true;
    const getSelectSpeakers = true;

    const { selectDiscussions, selectSpeakers } =
        useDiscussionsClubsHostsInternalHosts({
            getSelectDiscussions,
            getSelectSpeakers,
        });

    const mergeSpeakerAndInternalHost = selectSpeakers;

    const fetchExistingFiles = useCallback(async discussionid => {
        if (!discussionid) {
            setExistingFiles([]);
            return;
        }

        setLoadingFiles(true);
        try {
            const resp = await axios.post(
                `${globalURLS.baseURL}ADgetDiscussionFiles`,
                { discussionid },
                globalURLS.config,
            );
            setExistingFiles(resp?.data?.data || []);
        } catch (err) {
            console.error(err);
            setExistingFiles([]);
            setShowErrorToast(true);
        } finally {
            setLoadingFiles(false);
        }
    }, [setShowErrorToast]);

    useEffect(() => {
        if (selectedDiscussion?.value) {
            fetchExistingFiles(selectedDiscussion.value);
        } else {
            setExistingFiles([]);
        }
    }, [selectedDiscussion, fetchExistingFiles]);

    const resetForm = () => {
        setSelectedDiscussion(null);
        setExistingFiles([]);
        setinputList([{ name: '', file: null, authorid: '' }]);
        setValidated(false);
        setUpdatingFileId(null);
    };

    const handleinputchange = (name, val, index) => {
        const list = [...inputList];
        if (name === 'file') {
            list[index][name] = val.target.files[0];
        } else {
            list[index][name] = val?.value ? val?.value : val?.target?.value;
        }
        setinputList(list);
    };

    const handleremove = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setinputList(list);
    };

    const handleaddclick = () => {
        setinputList([...inputList, { name: '', file: null, authorid: '' }]);
    };

    const btnclose = () => {
        setAddFilesModal(false);
        resetForm();
    };

    const handleUpdateFileStatus = async (fileid, isactive) => {
        if (!fileid) return;

        setUpdatingFileId(fileid);
        try {
            const resp = await axios.post(
                `${globalURLS.baseURL}ADupdateDiscussionFileStatus`,
                { fileid, isactive },
                globalURLS.config,
            );

            if (resp?.data?.success === true) {
                setShowSuccessToast(true);
                setExistingFiles(prev =>
                    prev
                        .map(file =>
                            file.fileid === fileid
                                ? { ...file, isactive }
                                : file,
                        )
                        .sort(
                            (a, b) =>
                                Number(b.isactive) - Number(a.isactive),
                        ),
                );
            } else {
                setShowErrorToast(true);
            }
        } catch (err) {
            console.error(err);
            setShowErrorToast(true);
        } finally {
            setUpdatingFileId(null);
        }
    };

    const handleSubmit = async event => {
        event.preventDefault();
        event.stopPropagation();

        if (!selectedDiscussion?.value) {
            setShowErrorToast(true);
            return;
        }

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        const formData = new FormData();
        const discussionid = selectedDiscussion.value;
        const filteredList = inputList
            .filter(item => item.file)
            .map(item => ({ ...item, discussionid }));

        filteredList.forEach(item => {
            if (item.name && item.file) {
                formData.append(`${item.discussionid}_${item.name}`, item.file);
            }
        });

        const listWithoutFile = filteredList.map(({ file, ...rest }) => rest);
        formData.append('inputList', JSON.stringify(listWithoutFile));

        try {
            const resp = await axios.post(
                `${globalURLS.baseURL}addDiscussionFileV2`,
                formData,
                {
                    ...globalURLS.config,
                    headers: {
                        ...globalURLS.config.headers,
                        'Content-Type': 'multipart/form-data',
                    },
                },
            );

            if (resp?.data?.success === true) {
                setShowSuccessToast(true);
                setinputList([{ name: '', file: null, authorid: '' }]);
                setValidated(false);
                await fetchExistingFiles(discussionid);
            } else {
                setShowErrorToast(true);
            }
        } catch (err) {
            console.error(err);
            setShowErrorToast(true);
        }
    };

    return (
        <Container>
            <Col>
                <Modal show={openAddFilesModal} animation={false} size="lg">
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                    >
                        <Modal.Header>
                            <Modal.Title>Add Discussion Files</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="mb-3">
                                <div className="form-group col-md-12">
                                    <Form.Label>Discussion</Form.Label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={selectedDiscussion}
                                        onChange={val =>
                                            setSelectedDiscussion(val)
                                        }
                                        isSearchable
                                        options={selectDiscussions}
                                        placeholder="Select discussion..."
                                    />
                                </div>
                            </Row>

                            {selectedDiscussion?.value && (
                                <>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Label>
                                                Attached Files
                                            </Form.Label>
                                            {loadingFiles ? (
                                                <p className="text-muted mb-0">
                                                    Loading files...
                                                </p>
                                            ) : existingFiles.length === 0 ? (
                                                <p className="text-muted mb-0">
                                                    No files attached to this
                                                    discussion.
                                                </p>
                                            ) : (
                                                <div className="attached-files-list">
                                                    {existingFiles.map(file => {
                                                        const isActive =
                                                            Number(
                                                                file.isactive,
                                                            ) === 1;
                                                        const isUpdating =
                                                            updatingFileId ===
                                                            file.fileid;

                                                        return (
                                                            <div
                                                                key={
                                                                    file.fileid
                                                                }
                                                                className={`d-flex align-items-center justify-content-between border rounded px-3 py-2 mb-2 ${
                                                                    isActive
                                                                        ? ''
                                                                        : 'bg-light text-muted'
                                                                }`}
                                                            >
                                                                <div>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <span>
                                                                            {file.filename ||
                                                                                'Unnamed file'}
                                                                        </span>
                                                                        <small
                                                                            className={`badge ${
                                                                                isActive
                                                                                    ? 'bg-success'
                                                                                    : 'bg-secondary'
                                                                            }`}
                                                                        >
                                                                            {isActive
                                                                                ? 'Active'
                                                                                : 'Deleted'}
                                                                        </small>
                                                                    </div>
                                                                    {file.authorName && (
                                                                        <small className="text-muted">
                                                                            Author:{' '}
                                                                            {
                                                                                file.authorName
                                                                            }
                                                                        </small>
                                                                    )}
                                                                </div>
                                                                <div className="d-flex gap-2">
                                                                    {file.url && (
                                                                        <Button
                                                                            variant="outline-secondary"
                                                                            size="sm"
                                                                            href={
                                                                                file.url
                                                                            }
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            View
                                                                        </Button>
                                                                    )}
                                                                    {isActive ? (
                                                                        <Button
                                                                            variant="danger"
                                                                            size="sm"
                                                                            disabled={
                                                                                isUpdating
                                                                            }
                                                                            onClick={() =>
                                                                                handleUpdateFileStatus(
                                                                                    file.fileid,
                                                                                    0,
                                                                                )
                                                                            }
                                                                        >
                                                                            {isUpdating
                                                                                ? 'Deleting...'
                                                                                : 'Delete'}
                                                                        </Button>
                                                                    ) : (
                                                                        <Button
                                                                            variant="success"
                                                                            size="sm"
                                                                            disabled={
                                                                                isUpdating
                                                                            }
                                                                            onClick={() =>
                                                                                handleUpdateFileStatus(
                                                                                    file.fileid,
                                                                                    1,
                                                                                )
                                                                            }
                                                                        >
                                                                            {isUpdating
                                                                                ? 'Activating...'
                                                                                : 'Activate'}
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>

                                    <hr />

                                    <div className="row">
                                        {inputList.map((x, i) => {
                                            return (
                                                <Row key={i}>
                                                    <Row>
                                                        <div className="form-group col-md-6">
                                                            <Form.Label>
                                                                File Name
                                                            </Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                name="name"
                                                                className="form-control"
                                                                value={x.name}
                                                                onChange={e =>
                                                                    handleinputchange(
                                                                        'name',
                                                                        e,
                                                                        i,
                                                                    )
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please provide a
                                                                Name.
                                                            </Form.Control.Feedback>
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <Form.Label>
                                                                Author
                                                            </Form.Label>
                                                            <Select
                                                                closeMenuOnSelect={
                                                                    true
                                                                }
                                                                onChange={val =>
                                                                    handleinputchange(
                                                                        'authorid',
                                                                        val,
                                                                        i,
                                                                    )
                                                                }
                                                                isSearchable
                                                                options={
                                                                    mergeSpeakerAndInternalHost
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please provide a
                                                                AuthorID.
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </Row>
                                                    <Row>
                                                        <div className="form-group col-md-6">
                                                            <Form.Label>
                                                                Upload PDF
                                                            </Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="file"
                                                                accept="application/pdf"
                                                                className="form-control"
                                                                onChange={e =>
                                                                    handleinputchange(
                                                                        'file',
                                                                        e,
                                                                        i,
                                                                    )
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please upload a
                                                                PDF file.
                                                            </Form.Control.Feedback>
                                                        </div>

                                                        <div className="form-group col-md-6 d-flex align-items-end">
                                                            <Col>
                                                                {inputList.length !==
                                                                    1 && (
                                                                    <Button
                                                                        className="btn btn-danger mx-2 mb-2"
                                                                        onClick={() =>
                                                                            handleremove(
                                                                                i,
                                                                            )
                                                                        }
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                )}
                                                                {inputList.length -
                                                                    1 ===
                                                                    i && (
                                                                    <Button
                                                                        style={{
                                                                            width: 'auto',
                                                                        }}
                                                                        className="btn btn-success mx-2 mb-2"
                                                                        onClick={
                                                                            handleaddclick
                                                                        }
                                                                    >
                                                                        Add More
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </div>
                                                    </Row>
                                                </Row>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={btnclose}>
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={!selectedDiscussion?.value}
                            >
                                Add Files
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </Col>
        </Container>
    );
}

export default AddFiles;
